import React from 'react'
import './placeholder.css'

const Placeholder = (props) => (
  <span className='Placeholder' {...props} />
)

export default Placeholder
